import React from 'react'
import { CreditCard } from 'lucide-react'
import { MedicationCard } from './medication-card'

export interface MedicationSubscriptionAdjustedCardProps {
  medicationName: string
  dosage: string
  supply: string
  status?: 'pending' | 'approved' | 'denied' | 'discontinued' | 'active' | 'shipped' | 'delivered' | 'scheduled'
  className?: string
  onViewClick?: () => void
  onOkClick?: () => void
  onTitleClick?: () => void
}

export const MedicationSubscriptionAdjustedCard: React.FC<MedicationSubscriptionAdjustedCardProps> = ({
  medicationName,
  dosage,
  supply,
  status = 'pending',
  className = '',
  onViewClick,
  onOkClick,
  onTitleClick,
}) => {
  return (
    <div className={`w-full max-w-sm space-y-0 shadow-md rounded-lg bg-transparent ${className}`}>
      <MedicationCard
        medicationName={medicationName}
        dosage={dosage}
        supply={supply}
        status={status}
        className="rounded-b-none shadow-none"
        onTitleClick={onTitleClick}
        disableHover={true}
      />
      <div className="rounded-t-none rounded-b-lg p-4 border-l border-r border-b bg-muted/50">
        <div className="flex items-start gap-3 mb-1">
          <CreditCard className="h-4 w-4 text-foreground mt-0.5" />
          <h3 className="text-base font-semibold leading-none tracking-tight text-foreground">
            Subscription Adjusted
          </h3>
        </div>
        <p className="text-sm text-muted-foreground mb-3">
          Your subscription has been updated with the new medication changes.
        </p>
        <div className="flex gap-2">
          <button 
            onClick={onViewClick}
            className="inline-flex items-center justify-center rounded-md text-sm font-medium border border-input bg-background hover:bg-accent hover:text-accent-foreground h-9 px-3"
          >
            View
          </button>
          <button 
            onClick={onOkClick}
            className="inline-flex items-center justify-center rounded-md text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 h-9 px-3"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  )
}